// Minimal SearchForm base class for Shopify predictive search and main search
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.statusElement = this.querySelector('.predictive-search-status');
    this.loadingText = this.getAttribute('data-loading-text') || 'Loading...';
    this.setupInputListener();
  }

  setupInputListener() {
    if (this.input) {
      this.input.addEventListener('input', this.onChange.bind(this));
      this.input.addEventListener('reset', this.onFormReset?.bind(this));
    }
  }

  onChange() {
    // To be overridden by subclasses
  }

  onFormReset(event) {
    // To be overridden by subclasses
  }

  shouldResetForm() {
    return !this.input.value.length;
  }
}

window.SearchForm = SearchForm;
